export class VerifierPackagesRecord {
    PackageId:number;
    PackageName:string;
    PackageCost:number;
    IncludeSalaryInformation:boolean;
    PackageDetails:string;
    CustomerId:number; 
    IsActive:boolean;
    CreatedDt:Date;
    CustomerRate:any;

}